export const TrimLeadingWhiteSpace = (value) => {
    const whiteSpaceExp = /^\s+/;
    return value.replace(whiteSpaceExp, '');
};
//# sourceMappingURL=TrimLeadingWhiteSpace.js.map